import React from 'react';
import classnames from 'classnames';
import { ProgressIndicator } from '@eb/eds-progress-indicator';
import {
    IMPOSSIBLE_PRICE_TITLE,
    IMPOSSIBLE_PRICE_TEXT,
    ATTENDEE_PAYS,
} from '../../constants/pricing';

interface PriceResultsProps {
    eventTotal: string;
    impossiblePriceEncountered: boolean;
    isFree: boolean;
    isLoading: boolean;
    totalContent: string | JSX.Element;
}

const PriceResults = ({
    eventTotal,
    impossiblePriceEncountered,
    isFree,
    isLoading,
    totalContent,
}: PriceResultsProps) => {
    const eventTotalClasses = classnames(
        'eds-text-color--success',
        'eds-text--center',
        'eds-l-pad-vert-4',
        'eds-text-hm',
        'pricing-calculator--results-total',
        {
            'pricing-calculator--results-total--large': !isFree,
            'eds-align--center': !isFree,
            'pricing-calculator--results-total--long':
                !isFree && eventTotal.length > 8,
            'pricing-calculator--results-total--extra-long':
                !isFree && eventTotal.length > 10,
        },
    );

    if (isLoading) {
        return (
            <div className={eventTotalClasses}>
                <ProgressIndicator style="gradient" />
            </div>
        );
    }

    return impossiblePriceEncountered ? (
        <>
            <div className={eventTotalClasses}>{IMPOSSIBLE_PRICE_TITLE}</div>
            <div className="eds-align--center eds-l-pad-bot-6 eds-text-bl">
                {IMPOSSIBLE_PRICE_TEXT}
            </div>
        </>
    ) : (
        <>
            <div className={eventTotalClasses}>{eventTotal}</div>
            <div className="eds-align--center eds-l-pad-bot-1 eds-text-bl">
                {ATTENDEE_PAYS}
            </div>
            <div className="eds-align--center eds-l-pad-bot-6 eds-text-bl pricing-calculator--attendee-total">
                {totalContent}
            </div>
        </>
    );
};

export default PriceResults;
